<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
       
        <v-col cols="12" v-if="showGatewayPopup">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="specialInfoSingle"
            :form-data="cardTexts"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="gray"
                class="mt-10"
              ></v-progress-circular>
              <catalog-show
                v-else-if="cardTexts"
                v-model="cardTexts"
                :orders.sync="orders"
                :theme="catalogType"
                class="sticky-preview"
                :qr-svg-data-url="qrSvgDataUrl"
              />
            </template>
          </qr-edit-gateway>
        </v-col>

        <!-- فرم اصلی و استپر (زمانی که Gateway بسته است) -->
        <template v-if="!showGatewayPopup">
          <v-col
            class="pa-2 sticky-md"
            cols="12"
            md="4"
            style="top: 100px; height: fit-content"
          >
            <catalog-show
              v-if="cardTexts"
              v-model="cardTexts"
              :orders.sync="orders"
              :theme="catalogType"
              :qr-svg-data-url="qrSvgDataUrl"
            />
          </v-col>

          <v-col cols="12" md="8">
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>ویرایش اطلاعات کاتالوگ / بروشور</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0 rowinfo">
                    <v-text-field
                      v-model="res.title"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام کاتالوگ / بروشور شما"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام کاتالوک"
                    />
                  </div>
                  <div class="col-md-6 mt-0 pt-0 rowinfo">
                    <qr-address-field
                      id="qr-address"
                      ref="address-field"
                      v-model="res.identifier"
                      :domain-id="res.domain_id"
                      :error-messages="errors['identifier']"
                      append-icon="mdi-web"
                      class="mt-0 pt-0 contentinfo"
                      dense
                      outlined
                      persistent-hint
                      readonly
                      :key="$t('qrAddressUpdate.hints.allowedChars')"
                      :hint="$t('qrAddressUpdate.hints.allowedChars')"

                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-dtUrl`"
                      label="آدرس کیوآر"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                    />
                  </div>
                </div>
              </v-stepper-step>

              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>

                  <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>

                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  title="انتخاب نوع نمایش"
                  :service-name="serviceName"
                  :component-name="componentName"
                  @save-required="AutoSave && qrUpdate(false)"

                >
                  <template v-slot:content>
                    <catalog-types v-model="catalogType" :components="catTypes" />
                  </template>
                </list-expansion>

                <list-expansion
                  v-model="cardTexts"
                  :components="specialInfo"
                  :data="cardTexts"
                  :service-name="serviceName"
                  :component-name="componentName"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12 mt-5">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-col>
        </template>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { setDragging } from "@/utilities/DraggingKeysOrder";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import NextBtn from "@/view/content/fragments/nextBtn";
import ListExpansion from "@/view/content/fragments/listExpansion";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import catalogTypes from "@/view/pages/otherQrTypes/leafletCatalog/components/catalogTypes.vue";
import CatalogShow from "@/view/pages/otherQrTypes/leafletCatalog/components/CatalogShow";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { Bus, debounce } from "@/main";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editCatalog",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    CatalogShow,
    catalogTypes,
    ListExpansion,
    QrAddressField,
    NextBtn,
    QrEditGateway,
    AtomSpinner
  },

  data() {
    return {
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      showGatewayPopup: this.$route?.query?.gateway === 'true', // استیت Gateway
      helpData: [],
      serviceName: "Qrland",
      componentName: "leafletcatalogedit",
      e6: 1,
      loading: false,
      errors: {},
      res: {},
      cardTexts: {},
      orders: [],
      catalogType: "turning",
    };
  },

  mounted() {
    this.fetchData();
    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
    Bus.$on("colorPalette", (value) => {
      if (this.cardTexts.photo) this.cardTexts.photo.color = value;
    });
    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });
  },

  computed: {
    catTypes() {
      return [
        {
          name: "turning",
          title: this.$t("edit_bpage_special_info_special.turning"),
        },
        {
          name: "slide",
          title: this.$t("edit_bpage_special_info_special.slider"),
        },
        {
          name: "vertical",
          title: this.$t("edit_bpage_special_info_special.vertical"),
        },
      ];
    },

    specialInfo() {
      return [
        {
          name: "textCards",
          value: "",
          title: this.$t("edit_bpage_special_info_special.information"),
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: this.$t("edit_bpage_special_info_special.upload_logo"),
          icon: "image",
          model: "photo",
        },
        {
          name: "PicSelector",
          value: "",
          title: this.$t(
            "edit_bpage_special_info_special.upload_catalog_brochure_images"
          ),
          icon: "image",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("edit_bpage_special_info_special.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "colorPallete",
          value: "",
          title: this.$t("edit_bpage_special_info_special.select_color"),
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ];
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  specialInfoSingle() {
    const descriptionKeys = {
      textCards:
        "edit_catalog_special_info_single.text_cards_description",

      imageUploader:
        "edit_catalog_special_info_single.image_uploader_description",

      PicSelector:
        "edit_catalog_special_info_single.pic_selector_description",

      socialMediaIcons:
        "edit_catalog_special_info_single.social_media_icons_description",

      colorPallete:
        "edit_catalog_special_info_single.color_palette_description",
    };

    return this.specialInfo.map((item) => ({
      ...item,
      description: descriptionKeys[item.name]
        ? this.$t(descriptionKeys[item.name])
        : "",
    }));
  },
  },

  watch: {
    cardTexts: {
      deep: true,
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          debounce(() => {
            this.setKeys(newVal);
          }, 300);
        }
      },
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    
    // متدهای مربوط به Gateway
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      keys = keys.filter(
        (item) =>
          item.name !== "pallete" &&
          item.name !== "apiKey" &&
          item.name !== "center" &&
          item.name !== "coordinates",
      );

      this.orders = keys;
      this.$forceUpdate();
    },

    fetchData() {
      this.loading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          let info = data.data.data;
          this.res = data.data;
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          this.cardTexts = info.data || {};
          this.orders = info.orders || [];
          this.catalogType = info.theme || "turning";

          this.setKeys(this.cardTexts);
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => (this.loading = false));
    },

    qrUpdate(final = true) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "catalog");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("_method", "PUT");
      data.append("title", this.res.title);
      data.append("qr_id", this.res.qrId);

      data.append(
        "data",
        JSON.stringify({
          theme: this.catalogType,
          data: this.cardTexts,
          orders: this.orders,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data", // طبق کد اصلی شما application/from-data
          },
        })
        .then(({ data }) => {
          if(final || !this.AutoSave)
            this.$toast.success("کاتالوگ شما با موفقیت ویرایش شد.");
          
          if (final) {
            if (typeof this.goto === 'function') {
              this.goto("qr/list");
            } else {
              this.$router.push({ name: "qr.list" });
            }
          }
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
